export const EVENT_ICON_CHANGED: string = 'icon';
export const DATA_ICON: string = 'icon';
export const ATTRIBUTE_DATA_ICON: string = `data-${DATA_ICON}`;
export const ATTRIBUTE_CLASS: string = 'class';
